import React, {useContext} from "react";
import { css } from "emotion";
import EditButton from "./EditButton";
import { colors } from "../../styles/theme";
import TitleWithBackButton from "../TitleWithBackButton";
import {GlobalContext} from "../../context/GlobalState";

const TopRowWithEdit = () => {
  const {currentSpotlight} = useContext(GlobalContext);

  return (
    <div className={container}>
      <TitleWithBackButton backLocation="home" title={currentSpotlight.name} />
      <EditButton />
    </div>
  );
};

export default TopRowWithEdit;

const container = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid ${colors.inputBackground};
  margin-bottom: 20px;
`;
